import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatPaginatorModule } from '@angular/material/paginator';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SimplebarAngularModule } from 'simplebar-angular';
import { TextareaModule } from '../components/templates/textarea/textarea.module';
import { DaveDoubleIconModule } from '../dave-double-icon/dave-double-icon.module';
import { DaveLoadingModule } from '../dave-loading/dave-loading.module';
import { AppButtonModule } from '../dave-utils-module/app-button-module/app-button.module';
import { AppFilterModule } from '../dave-utils-module/app-filter-module/app-filter.module';
import { DaveSharedComponentsModule } from '../dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import { SelectSearchModule } from '../dave-utils-module/select-search/select-search.module';
import { TravelZoneSelectComponent } from '../travel-zone/components/travel-zone-select/travel-zone-select.component';
import { HourList2Component } from './components/hour-list-2/hour-list-2.component';
import { NewClockinPopupComponent } from './components/new-clockin-popup/new-clockin-popup.component';
import { TimeTrackerComponent } from './components/time-tracker/time-tracker.component';

@NgModule({
    declarations: [TimeTrackerComponent, NewClockinPopupComponent, HourList2Component],
    imports: [
        CommonModule,
        MatCardModule,
        MatButtonModule,
        FontAwesomeModule,
        ReactiveFormsModule,
        TextareaModule,
        AppButtonModule,
        MatDialogModule,
        SelectSearchModule,
        MatExpansionModule,
        MatTooltipModule,
        MatTableModule,
        MatFormFieldModule,
        MatSelectModule,
        DaveSharedComponentsModule,
        MatInputModule,
        SimplebarAngularModule,
        MatButtonToggleModule,
        MatSlideToggleModule,
        FormsModule,
        MatRadioModule,
        DaveLoadingModule,
        AppFilterModule,
        MatBadgeModule,
        MatListModule,
        TravelZoneSelectComponent,
        DaveDoubleIconModule,
        MatPaginatorModule,
    ],
    exports: [TimeTrackerComponent, NewClockinPopupComponent, HourList2Component],
})
export class DaveTimeTrackerModule {}
